const RULES_FILTER_OPTIONS = [
  {
    type: 'matched',
    name: 'matched',
    value: '',
    options: [
      {
        label: 'All',
        value: '',
      },
      {
        label: 'Matched',
        value: 1,
      },
      {
        label: 'Needs configuration',
        value: 2,
      },
    ],
  },
  {
    label: 'Show archived',
    type: 'switch',
    name: 'archived',
    value: '',
    options: [
      {
        label: 'ON',
        value: '',
      },
      {
        label: 'OFF',
        value: false,
      },
    ],
  },
];

export default RULES_FILTER_OPTIONS;
